import React from 'react';

/**
 * 简化的权限检查工具
 * 直接基于菜单配置中的roles数组进行权限验证
 */

// 检查用户是否有权限访问指定角色要求
export const hasPermission = (userRole, requiredRoles) => {
    // 如果没有角色要求，表示完全公开
    if (!requiredRoles || requiredRoles.length === 0) {
        return true;
    }
    
    // 检查用户角色是否在允许的角色列表中
    return requiredRoles.includes(userRole);
};

// 过滤菜单项（基于用户角色）
export const filterMenuByPermission = (menuList, userRole) => {
    return menuList.filter(item => {
        // 检查当前菜单项权限
        if (!hasPermission(userRole, item.roles)) {
            // 如果主菜单没权限，检查是否有子菜单有权限
            if (item.children && item.children.length > 0) {
                const accessibleChildren = item.children.filter(child => 
                    hasPermission(userRole, child.roles)
                );
                return accessibleChildren.length > 0;
            }
            return false;
        }
        
        // 如果有子菜单，递归过滤
        if (item.children) {
            item.children = filterMenuByPermission(item.children, userRole);
        }
        
        return true;
    });
};

// 检查路由权限
export const checkRoutePermission = (userRole, requiredRoles) => {
    return hasPermission(userRole, requiredRoles);
};

// 权限检查组件（用于页面内的细粒度权限控制）
export const PermissionCheck = ({ userRole, requiredRoles, children, fallback = null }) => {
    if (hasPermission(userRole, requiredRoles)) {
        return children;
    }
    return fallback;
};

// 获取角色显示名称
export const getRoleDisplayName = (role) => {
    const roleMap = {
        admin: "管理员",
        editor: "编辑员",
        'health-manager': "健康管理师", 
        doctor: "专科医生",
        guest: "访客"
    };
    return roleMap[role] || role;
};

export default {
    hasPermission,
    filterMenuByPermission,
    checkRoutePermission,
    PermissionCheck,
    getRoleDisplayName
}; 